// Copyright (C) 2022 Intel Corporation
//
// SPDX-License-Identifier: MIT
import './styles.scss';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spin from 'antd/lib/spin';
import { Col, Row } from 'antd/lib/grid';
import Empty from 'antd/lib/empty';
import Text from 'antd/lib/typography/Text';
import { getCore } from 'cvat-core-wrapper';
import UserList from './user-list';
import { getJobsAsync } from 'actions/jobs-actions';
import { CombinedState } from 'reducers';

interface Props {
    users: any[];
    submissions: any[];
    jobs: any[];
    count: number;
    fetching: boolean;
}

function UsersComponent(props: Props): JSX.Element {
    return (
        <div className='cvat-assignment-page'>
            <Row justify='space-around' about='middle'>
                <Col sm={23}>
                    <UserList
                        users={props.users}
                        jobs={props.jobs}
                        submissions={props.submissions}
                        fetching={props.fetching}
                    />
                </Col>
            </Row>
        </div>
    );
}

export default React.memo(UsersComponent);
